import { BaseError } from './base';

export class NoSmartWalletAccountSignerFoundError extends BaseError {
  constructor(smartWalletAddress: string) {
    super({
      cause: null,
      code: 'no_smart_wallet_account_signer_found_error',
      docsUrl: null,
      name: 'NoSmartWalletAccountSignerFoundError',
      shortMessage: `No signer wallet account found for smart wallet account ${smartWalletAddress}`,
    });
  }
}
